var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/InvestmentAllocationConstants');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var InvestmentAllocationStore = require('./InvestmentAllocationStore');
var Products = require('../utils/Products.js');
var PensionTypeConstants = require('../constants/PensionTypeConstants.js');
var ApplicationConstants = require('../constants/ApplicationConstants');
var ApplicationActionTypes = require('../constants/ApplicationConstants').ActionTypes;
var InvestmentAllocationActionTypes = require('../constants/InvestmentAllocationConstants').ActionTypes;
var ActionTypes = Constants.ActionTypes;
var CHANGE_EVENT = 'change';

var _list = [];
var _trisOptionlist = [];
var _nonTrisOptionlist = [];
var _searchVisible = true;
var _isAddInvestmentOption = true;
var _isPreRetirement = true;
var _productId;
var _firstRateCashNonAutoRebalancingOptions = [];
var _isFirstRateCashNonAutoRebalancing = ApplicationConstants.YesNoValues.NO;

function retrieveInvestmentOption(applicationData) {
    var investmentOptions = _.get(applicationData, 'form.investmentAllocation.investmentOptions');
    if (investmentOptions) {
        setSearchVisibilityOnInvestmentAllocationUpdate(investmentOptions);
    }
}

function loadInvestmentOptionList(investmentOptionList) {   
        
    investmentOptionList.map(function (obj) {
        _list.push({
            value: obj.id,
            label: obj.code == ' ' ? obj.name : obj.name + ' - ' + obj.code,
            name: obj.name,
            code: obj.code,
            weight: obj.weight,
            termDeposit: obj.termDeposit,
            fmsCode: obj.fmsCode,
            rebatePaymentOption: obj.rebatePaymentOption,
            groupSequenceNumber: obj.groupSequenceNumber,
            redemptionSequenceNumber: obj.redemptionSequenceNumber,
            isFirstRateInvestment: obj.isFirstRateInvestment,
            preRetirementIndicator: obj.preRetirementIndicator,
            minTimeframe: obj.minTimeframe,
            riskLabel: obj.riskLabel
        });
    });
    _list.sort(function compareLabelProp(obj1, obj2) {
        if (obj1.label < obj2.label) {
            return -1;
        }
        else if (obj1.label > obj2.label) {
            return 1
        }
        return 0;
    });    
    populateTrisAndNonTrisInvestmentOption();
    populateFirstRateCashNonAutoRebalancingOptions();
    InvestmentAllocationStore.clearInvestmentSearch();
}

function clearInvestmentList()
{
    _list = InvestmentAllocationStore.getRemovedItems();
}
    
// Method to load isSearchVisible from clicking the button
function toggleSearchVisibility(visible) {
    _searchVisible = visible;
    _isAddInvestmentOption = visible;
}

// Method to remove multiple investment options
function removeInvestmentOptions(investmentOptionList) {
    _.forEach(investmentOptionList, function (removeObj) {
        _list = _list.filter(function (obj) {
            return obj.value !== parseInt(removeObj.id);
        });
    });
}

function populateFirstRateCashNonAutoRebalancingOptions() {
    if(Products.isPension(_productId) && _isPreRetirement){
        _firstRateCashNonAutoRebalancingOptions = _list.filter((x) => x.termDeposit ===  true || x.value === Constants.FirstRateTTRSaverNonAutoRebalancing);
    }else if(Products.isPension(_productId) && !_isPreRetirement){
        _firstRateCashNonAutoRebalancingOptions = _list.filter((x) => x.termDeposit ===  true || x.value === Constants.FirstRateSaverNonAutoRebalancing);
    }else if(Products.isInvestment(_productId)){
        _firstRateCashNonAutoRebalancingOptions = _list.filter((x) => x.termDeposit ===  true || x.value === Constants.FirstRateCashNonAutoRebalancing);
    }else{
        _firstRateCashNonAutoRebalancingOptions = _list.filter((x) => x.termDeposit ===  true || x.value === Constants.FirstRateSaverNonAutoRebalancing);
    }
    _firstRateCashNonAutoRebalancingOptions.forEach(x => {
        x.cashOption = true
    });
}

// Method to filter tris or non-tris investmentoption
function populateTrisAndNonTrisInvestmentOption() {
    
    _trisOptionlist = _list.filter(function (obj) {
        return obj.preRetirementIndicator == 'Y';
    });

    _nonTrisOptionlist = _list.filter(function (obj) {
        return obj.preRetirementIndicator != 'Y';
    });
}

// Method to hide or show the search component based on table allocation count
function setSearchVisibilityOnInvestmentAllocationUpdate(list) {
    if (list.length <= 0) {
        toggleSearchVisibility(true);
    }
    else {
        toggleSearchVisibility(false);
    }
}

function toggleIsAddInvestmentOption(value) {
    _isAddInvestmentOption = value;
}

function setPensionTypeSelected(selectedPensionType) {
    if (Products.isPension(_productId) &&
        selectedPensionType == PensionTypeConstants.PensionTypeSelectionNames.PRE_RETIREMENT) {
        _isPreRetirement = true;
    } else {
        _isPreRetirement = false;
    }
}

function setProductId(productId) {
    _productId = productId;
}

function setIsFirstRateCashNonAutoRebalancing(value) {
    _isFirstRateCashNonAutoRebalancing = value;
}

var InvestmentOptionStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    /**
     * @param {function} callback
     */
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    /**
     * @param {function} callback
     */
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    // Return Investment Option list
    getList: function () {
        let returnList = [];

        if (Products.isPension(_productId) && _isPreRetirement) {
            returnList = _trisOptionlist;
        } else if (Products.isPension(_productId) && !_isPreRetirement) {
            returnList = _nonTrisOptionlist;
        } else {
            returnList = _list;
        }

        if(_isFirstRateCashNonAutoRebalancing == ApplicationConstants.YesNoValues.YES)
            returnList = returnList.filter(x => !x.termDeposit && x.value !== Constants.FirstRateSaverNonAutoRebalancing);

        return returnList;
    },
    // Return search visibility
    searchVisible: function () {
        return _searchVisible;
    },

    getIsAddInvestmentOption: function () {
        return _isAddInvestmentOption;
    },

    getIsPreRetirement: function () {
        return (Products.isPension(_productId) && _isPreRetirement);
    },

    getFirstRateCashNonAutoRebalancingOptions: function () {
        return _firstRateCashNonAutoRebalancingOptions;
    }

});

InvestmentOptionStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            retrieveInvestmentOption(action.applicationData);
            break;
            //Action for recieving lists from API
        case ActionTypes.RECEIVE_INVESTMENT_OPTION_LIST:
            clearInvestmentList();
            loadInvestmentOptionList(action.investmentOptionList);
            removeInvestmentOptions(InvestmentAllocationStore.getList());
            break;

        //Action for removing investment options when table is pre populated
        case ActionTypes.RECEIVE_ALLOCATED_INVESTMENT_OPTIONS:
            AppDispatcher.waitFor([InvestmentAllocationStore.dispatchToken]);
            removeInvestmentOptions(InvestmentAllocationStore.getList());
            break;

        //Action for clicking the Add fund button
        case ActionTypes.TOGGLE_SEARCH_VISIBILITY:
            toggleSearchVisibility(action.searchVisible);
            break;

        case ActionTypes.TOGGLE_IS_ADD_INVESTMENT_OPTION:
            toggleIsAddInvestmentOption(action.value);
            break;

        //Action for updating the isSearchVisible based on investment allocation table count
        case ActionTypes.UPDATE_SEARCH_VISIBLE:
            setSearchVisibilityOnInvestmentAllocationUpdate(InvestmentAllocationStore.getList());
            break;

        //Action for removing investment option in investmen allocation table 
        //and adding it to investment option list
        case ActionTypes.REMOVE_INVESTMENT_OPTION:            
            AppDispatcher.waitFor([InvestmentAllocationStore.dispatchToken]);
            loadInvestmentOptionList(InvestmentAllocationStore.getRemovedItems());
            break;

        case ApplicationActionTypes.SEND_INSPECIE_DECISIONS:
            AppDispatcher.waitFor([InvestmentAllocationStore.dispatchToken]);
            loadInvestmentOptionList(InvestmentAllocationStore.getRemovedItems());
            setSearchVisibilityOnInvestmentAllocationUpdate(InvestmentAllocationStore.getList());
            break;
            
        //Action for removing portfolio investment options in investmen allocation table 
        //and adding it to investment option list
        case ActionTypes.CLEAR_INVESTMENT_OPTIONS:           
            AppDispatcher.waitFor([InvestmentAllocationStore.dispatchToken]);
            loadInvestmentOptionList(InvestmentAllocationStore.getRemovedItems());
            break;

        //Action for clicking an option from the search box
        case ActionTypes.ADD_INVESTMENT_OPTION:
            removeInvestmentOptions(action.investmentOptions);
            break;

        //Action for listening the pension type selection
        case ApplicationActionTypes.IS_PENSION_TYPE_SELECTED:
            setPensionTypeSelected(action.selectedPensionType);
            break;

        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;
        
        case InvestmentAllocationActionTypes.TOGGLE_FIRST_RATE_CASH_NON_AUTO_REBALANCING:
            setIsFirstRateCashNonAutoRebalancing(action.value);
            break;
        default:
            return true;
    }
    // If action was responded to, emit change event
    InvestmentOptionStore.emitChange();

    return true;

});

module.exports = InvestmentOptionStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/InvestmentOptionStore.js